import React from 'react'

import __difference from 'lodash/difference'
import __escapeRegExp from 'lodash/escapeRegExp'

import type { CommonFilterSelectProps } from './types'
import { WidgetFilterSelect } from './WidgetFilterSelect'

interface FilterSelectProps<Payload extends Record<string, SelectableFilterOption[]>>
  extends Omit<CommonFilterSelectProps<Payload>, 'selectableOptions' | 'selectedOptions'> {
  disabled?: boolean
  options: SelectableFilterOption[]
  value: SelectableFilterOption[]
}

export function FilterSelect<Payload extends Record<string, SelectableFilterOption[]>>({
  disabled,
  emptyPlaceholder,
  keyValue,
  labelText,
  onChange,
  options,
  selectedLabelText,
  value,
}: FilterSelectProps<Payload>) {
  const [searchTerm, setSearchTerm] = React.useState('')

  const selectedOptions = React.useMemo(() => {
    const optionIds = options.map(({ id }) => id)
    return value.filter(({ id }) => optionIds.includes(id))
  }, [options, value])

  const selectableOptions = React.useMemo(() => {
    const diffOptions = __difference(options, selectedOptions)

    if (searchTerm) {
      const regex = new RegExp(__escapeRegExp(searchTerm), 'i')

      return diffOptions.filter(option => regex.test(option.name))
    }
    return diffOptions
  }, [options, searchTerm, selectedOptions])

  // PageFilterBar widget
  return (
    <WidgetFilterSelect
      disabled={disabled}
      emptyPlaceholder={emptyPlaceholder}
      keyValue={keyValue}
      labelText={labelText}
      onChange={onChange}
      searchTerm={searchTerm}
      selectableOptions={selectableOptions}
      selectedLabelText={selectedLabelText}
      selectedOptions={selectedOptions}
      setSearchTerm={setSearchTerm}
      value={value}
    />
  )
}
